
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/financial/monthly-sales",
      function () {
        return require("private-next-pages/ir/financial/monthly-sales.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/financial/monthly-sales"])
      });
    }
  